/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  fetchUserRequests,
  resetStateUsers,
  updateUserRequest,
} from "../../app/slices/usersSlice";
import TopLinks from "../../components/TopLinks/TopLinks";
import AppDataTable from "../../components/appDataTable/appDataTable";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";

import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../app/slices/commonSlice";
import ConfirmationDialog from "../../components/confirmationDialog/ConfirmationDialog";

const UserRequests = () => {
  const {
    list: listRequests,
    status: statusGet,
    error: errorGet,
  } = useSelector(({ users }) => users.requests);
  const {
    data: dataPut,
    error: errorPut,
    status: statusPut,
  } = useSelector(({ users }) => users.putRequests);

  const topLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "Registration Requests",
      isCurrent: true,
    },
  ];

  const columns = [
    {
      name: "REQUEST_ID",
      label: "Request ID",
      options: {
        visible: false,
      },
    },
    {
      name: "FULL_NAME",
      label: "Full Name",
    },
    {
      name: "COMPANY_NAME",
      label: "Company Name",
    },
    {
      name: "INCORPORATION_NUMBER",
      label: "Incorporation Number",
    },
    {
      name: "EMAIL",
      label: "Email",
    },
    {
      name: "PHONE_NUMBER",
      label: "Phone",
    },
    {
      name: "REGISTERED_AS",
      label: "Registering as",
    },
  ];

  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateUsers());
    };
  }, []);

  useEffect(() => {
    if (errorPut) {
      dispatch(
        showSnackbar({
          open: true,
          message: errorPut?.message || "An error occurred",
          type: "error",
        })
      );
    }
  }, [errorPut]);

  useEffect(() => {
    if (dataPut) {
      dispatch(
        showSnackbar({
          open: true,
          message: `Request ${
            dialogData?.status === "A" ? "approved" : "rejected"
          } successfully`,
          type: "success",
        })
      );
      setTimeout(() => {
        setIsOpenConfirm(false);
        setDialogData(null);
        loadResources();
      }, 400);
    }
  }, [dataPut]);
  //methods

  const loadResources = () => {
    dispatch(resetStateUsers());
    dispatch(fetchUserRequests({ STATUS: "P" }));
  };

  const handleUpdateRequest = () => {
    dispatch(
      updateUserRequest({
        id: dialogData?.request?.REQUEST_ID,
        payload: {
          STATUS: dialogData?.status,
        },
      })
    );
  };

  //builders
  return (
    <>
      <TopLinks links={topLinks} />

      {statusGet === "loading" && (
        <LoadingContainer
          hasBackground={true}
          message="Loading requests"
          id="loading-container-requests"
        />
      )}

      {errorGet !== null && statusGet !== "loading" && (
        <ErrorContainer
          id="error-container-requests"
          hasBackground={true}
          message={errorGet?.message || "An error occurred"}
          onReload={() => {
            loadResources();
          }}
        />
      )}

      {statusGet === "idle" && listRequests?.length <= 0 && (
        <EmptyDataContainer
          message="No user registration requests found"
          hasBackground={true}
          id="empty-data-users"
        />
      )}

      {listRequests?.length > 0 &&
        errorGet === null &&
        statusGet === "idle" && (
          <AppDataTable
            id="user-request-list"
            actions={[
              {
                action: "Approve",
                onClick: (item) => {
                  setDialogData({
                    request: item,
                    message: "Are you sure you want to approve this request?",
                    title: "Approve user registration request.",
                    status: "A",
                  });
                  setIsOpenConfirm(true);
                },
              },
              {
                action: "Reject",
                onClick: (item) => {
                  setDialogData({
                    request: item,
                    message: "Are you sure you want to reject this request?",
                    title: "Reject user registration request.",
                    status: "R",
                  });
                  setIsOpenConfirm(true);
                },
              },
            ]}
            columns={columns}
            data={listRequests}
            emptyMessage="Nothing found"
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName="System Users"
          />
        )}

      {/* Confirmation Dialog */}
      {isOpenConfirm && (
        <ConfirmationDialog
          handleResponse={handleUpdateRequest}
          onClose={() => {
            setIsOpenConfirm(false);
          }}
          open={isOpenConfirm}
          message={dialogData?.message}
          title={dialogData?.title}
          isLoading={statusPut === "loading"}
        />
      )}
      {/* Confirmation Dialog */}
    </>
  );
};

export default UserRequests;
